export default {
  title: {
    interviewMeetingRoomManagement: '面试会议室管理',
    addInterviewMeetingRoom: '添加',
    editInterviewMeetingRoom: '编辑'
  },
  menu: '面试会议室管理',
  label: {
    cnName: '中文名称',
    name: '英文名称',
    address: '地址',
    email: '邮箱',
    note: '备注'
  },
  btn: {
    addInterviewMeetingRoom: '添加'
  },
  message: {
    optionSuccess: '保存成功',
    optionField: '保存失败，请重试',
    deleteSuccess: '删除成功',
    deleteInfo: '确定删除{address} - {name}会议室吗？'
  },
  placeholder: {
    cnName: '请输入中文名称',
    name: '请输入英文名称',
    address: '请输入地址',
    email: '请输入邮箱',
    note: '请输入备注',
    search: '关键字搜索'
  }
}
